import { getUsageBreakdown } from '@kyumo/common';
import { formatNumber } from './chart-utils';

export type TokenColor = 'blue' | 'cyan' | 'teal' | 'green';

interface TokenBreakdownItemProps {
  label: string;
  value: number;
  color: TokenColor;
}

const colorClasses: Record<TokenColor, string> = {
  blue: 'text-blue-400',
  cyan: 'text-cyan-400',
  teal: 'text-teal-400',
  green: 'text-green-400',
};

/**
 * トークン内訳アイテムコンポーネント
 */
export function TokenBreakdownItem({ label, value, color }: TokenBreakdownItemProps) {
  return (
    <div className="text-center">
      <p className="text-muted-foreground text-sm mb-1">{label}</p>
      <p className={`text-xl font-bold ${colorClasses[color]}`}>{formatNumber(value)}</p>
    </div>
  );
}

interface TokenBreakdownProps {
  /** 入力トークンの合計（キャッシュ読込・書込を含む） */
  inputTokens: number;
  cacheReadTokens: number;
  cacheWriteTokens: number;
  outputTokens: number;
}

/**
 * トークン内訳セクションコンポーネント
 */
export function TokenBreakdown({
  inputTokens,
  cacheReadTokens,
  cacheWriteTokens,
  outputTokens,
}: TokenBreakdownProps) {
  // 内訳として並べるため、入力はキャッシュ分を除いて表示する
  // （集計は推論トークンを記録しないため、出力は推論を含んだまま表示される）
  const breakdown = getUsageBreakdown({
    inputTokens,
    outputTokens,
    cacheReadTokens,
    cacheWriteTokens,
  });
  return (
    <div className="bg-card rounded-xl p-6 border border-border mb-8">
      <h2 className="text-lg font-semibold text-foreground mb-4">トークン内訳</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <TokenBreakdownItem label="入力トークン" value={breakdown.input} color="blue" />
        <TokenBreakdownItem label="キャッシュ読込" value={breakdown.cacheRead} color="cyan" />
        <TokenBreakdownItem label="キャッシュ書込" value={breakdown.cacheWrite} color="teal" />
        <TokenBreakdownItem label="出力トークン" value={breakdown.output} color="green" />
      </div>
    </div>
  );
}
